<template>
  <span v-if="getStatus[arrematante.status]" :class="'text-' + getStatus[arrematante.status].class">
              <i class="fa fa-bell" v-if="arrematante.status === 0"></i>
              <i class="fa fa-check" v-if="arrematante.status === 1"></i>
              {{ getStatus[arrematante.status].titulo }}
            </span>
</template>

<script>
import * as Status from '../../../../domain/arrematantes/helpers/ArrematanteStatus'
export default {
  name: 'AnaliseAStatus',
  props: ['arrematante'],
  computed: {
    getStatus () {
      return Status.Status
    }
  }
}
</script>



// WEBPACK FOOTER //
// AnaliseAStatus.vue?3f08b275